export function resizeImage(img) {
  var max_width = 350;
  var max_height = 350;
  var width = img.width;
  var height = img.height;

  // calculate the width and height, constraining the proportions
  if (width > height) {
    // if (width > max_width) {
    //height *= max_width / width;
    height = Math.round((height *= max_width / width));
    width = max_width;
    // }
  } else {
    // if (height > max_height) {
    //width *= max_height / height;
    width = Math.round((width *= max_height / height));
    height = max_height;
    // }
  }

  // resize the canvas and draw the image data into it
  var canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);

  return canvas.toDataURL("image/jpeg", 0.65);
}
